import * as Yup from "yup";
import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import { toast } from "react-toastify";
import { requestAuth } from "../../components/services/RequestService";
import View from "../../components/GeneratePdf/View";
import Text from "../../components/GeneratePdf/Text";
import { useAuth } from "../../contexts/AuthContext";
import { useDialog } from "../../contexts/DialogContext";
import { Button } from "../../components/Buttons";
import FormDefault from "../../components/Forms/FormDefault";
import { Page, Document, PDFViewer, Image, pdf } from "@react-pdf/renderer";
import React from "react";
import * as dayjs from "dayjs";
import { faTextWidth } from "@fortawesome/free-solid-svg-icons";
dayjs.locale("es");


const RenderSettlement = (props) => {
  const { openDialog } = useDialog();

  const { data, loading } = Request({
    urlApi: "/dropdown/user/accountNumbers",
  });

  function handleProform(values) {
    openDialog(
      <Proform {...props} accountNumber={values.account} />
    );
  }

  function handleAccount() {
    const list = data.map((item) =>
      item.accountNumber
        ? {
          label: `${item.accountNumber} - ${item.name} ${item.fatherLastName}`,
          value: item.accountNumber,
        }
        : null
    );
    return list.filter((n) => n);
  }

  if (!loading) {
    return <Circle />;
  }
  return (
    <FormDefault
      tittle="Elaborador por/ Nro de Cuenta Bancaria a Depositar"
      fields={[
        {
          label: "Atención",
          name: "account",
          typeInput: "select",
          options: handleAccount(),
          //   [
          //   {
          //     label: "Original",
          //     value: "Original",
          //   },
          //   {
          //     label: "Copia",
          //     value: "Copia",
          //   },
          //   {
          //     label: "Fotocopia simple",
          //     value: "Fotocopia simple",
          //   },
          //   {
          //     label: "Fotocopia legalizada",
          //     value: "Fotocopia legalizada",
          //   },
          // ],
          // typeInput: "selectNewOption",
          // urlApi: "/dropdown/user/accountNumbers",
          // value: "name",
          // labelOption: "name",
        },
      ]}
      initialValues={{
        account: "",
      }}
      validationSchema={Yup.object().shape({
        // atn: Yup.string().required("Campo requerido"),
      })}
      onSubmit={handleProform}
      buttonName="Registrar"
    />
  );
};

const Proform = (props) => {
  const { procedure, accountNumber, isQuotation } = props;
  const { user } = useAuth();
  const fieldnames = [
    "serviciosAduaneros",
    "usoSistema",
    "i_E_H_",
    "i_C_E_",
    "i_V_A_",
    "G_A_",
    "BASE IMP_",
    "f6TotalValorFob",
    "fleteIYIi",
    "f8TotalCostoDelSeguro",
    "f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos",
    "gastosPuerto",
    "otrosErogaciones",
    "f10TotalValorCifAduana",
    "descripciónDeLaMercancía",
    "medioDeTransporte",
    "nro_DeFactura",
    "proveedor",
    "f3TotalNúmeroDeBultos",
    "f4TotalPesoBruto",
    "contacto",
    "nrocotizacion",
    "cifUsd",
    "gaPorcentaje",
    "ivaPorcentaje",
    "icePorcentaje",
    "iehPorcentaje",
    "TipoDeCambio"
  ];

  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.id || procedure.procedureId}/dataValues?${fieldnames.map(f => `fieldnames=${encodeURIComponent(f)}`).join("&")}`,
  });

  if (!loading) {
    return <div className="p-2"><Circle /></div>;
  }

  const parseValue = (val) => {
    if (!val) return 0;
    const parsed = parseFloat(val.toString().replace(",", "."));
    return isNaN(parsed) ? 0 : parsed;
  };
  //para CONCEPTOS Y VALORES
  const tc = parseValue(data.TipoDeCambio);
  const f6TotalValorFob = parseValue(data.f6TotalValorFob);

  const rawFlete = parseValue(data.fleteIYIi);
  const fleteVal = rawFlete === 0 ? f6TotalValorFob * 0.05 : rawFlete;

  const rawSeguro = parseValue(data.f8TotalCostoDelSeguro);
  const seguroVal = rawSeguro === 0 ? f6TotalValorFob * 0.02 : rawSeguro;

  const rawCifUsd = parseValue(data["cifUsd"]);
  const cifUsdVal = !rawCifUsd
    ? f6TotalValorFob + fleteVal + seguroVal + parseValue(data["f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos"]) + parseValue(data.gastosPuerto)
    : rawCifUsd;
  
  const cifBstc = cifUsdVal * tc;

  const rawCifBs = parseValue(data?.f10TotalValorCifAduana);
  const cifBsVal = !rawCifBs ? Math.round(cifBstc) : rawCifBs;

  //Para TRIBUTOS ADUANEROS
  const gaPorcent = parseValue(data.gaPorcentaje) / 100;
  const ivaPorcent = parseValue(data.ivaPorcentaje) / 100;
  const icePorcent = parseValue(data.icePorcentaje) / 100;
  const iehPorcent = parseValue(data.iehPorcentaje) / 100;

  const rawGa = parseValue(data["G_A_"]);
  const gaVal = rawGa === 0 ? Math.ceil(cifBsVal * gaPorcent) : rawGa;

  const rawBaseImp = parseValue(data["BASE IMP_"]);
  const baseImpVal = rawBaseImp === 0 ? cifBsVal + gaVal : rawBaseImp;

  const rawIva = parseValue(data["i_V_A_"]);
  const ivaVal = rawIva === 0 ? Math.ceil(baseImpVal * ivaPorcent) : rawIva;

  const rawIce = parseValue(data["i_C_E_"]);
  const iceVal = rawIce === 0 ? Math.round(baseImpVal * icePorcent) : rawIce;

  const rawIehd = parseValue(data["i_E_H_"]);
  const iehdVal = rawIehd === 0 ? Math.round(baseImpVal * iehPorcent) : rawIehd;

  const usoSistemaVal = parseValue(data["usoSistema"]);
  
  //Para CONCEPTOS Y VALORES

  const calculatedServices = (data.serviciosAduanerosSubDatas || [])
    .map(item => {
      const labelName = item.label || "";
      let value = parseValue(item.description);

      if (labelName.trim().toUpperCase() === "ALMACENAJE" && value === 0) {
        value = Math.ceil(cifBsVal * 0.008);
      }

      return { label: labelName, value };
    })
    .sort((a, b) => {
      if (a.label.trim().toUpperCase() === "ALMACENAJE") return -1;
      if (b.label.trim().toUpperCase() === "ALMACENAJE") return 1;
      return 0;
    });

  const totalServicios = calculatedServices.reduce((acc, item) => acc + item.value, 0);

  const totalTributos =
      gaVal +
      ivaVal +
      iceVal +
      iehdVal +
      usoSistemaVal;

  const granTotal = totalServicios + totalTributos;

  async function handleOnClick() {
    await pdf(MyDoc)
      .toBlob()
      .then((r) => {
        var file = new File([r], `Planilla-${dayjs().format("DD-MM-YYYY")}`);
        //uploadFile(file);
      });
  }

  const MyDoc = (
    <Document>
      <Page size="A4" style={{ padding: "40px" }}>
        <Image
          src={
            // 'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763749558/TRAZO/LOGOS/Imagen1_dwsaix.png'
            user?.institutionParam?.find(d => d.code === 'logo')?.value ?? ""
          } // o la URL del logo
          style={{
            position: "absolute",
            top: "8%",
            left: "10%",
            width: "580px", // ajusta tamaño
            height: "580px",
            opacity: 0.1, // opacidad baja para que sea marca de agua
            transform: "translate(-50%, -50%)", // centra la imagen
            zIndex: 0,
          }}
        />
        <View
          justifyContent="space-between"
          alignItems="center"
        // padding="4px 4px"
        >
          <View width="50%">
            <Image src={
              // 'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763749558/TRAZO/LOGOS/Imagen1_dwsaix.png'
              user?.institutionParam?.find(d => d.code === 'logo')?.value ?? ""
            } style={{ height: "100px" }} />
          </View>
          <View
            width="25%"
            flexDirection="column"
          // alignItems="flex-start"
          // justifyContent="flex-start"
          >
            <View style={{ flexDirection: "row" }}>
              <Text padding="0px 3px"
                fontSize="10px"
                // bold
                // textAlign="end"

                justifyContent="flex-start" >PRO-FORMA    </Text>
              <Text
                // color="#213a8f"
                padding="0px 3px"
                fontSize="10px"
                // bold
                textAlign="start"

                justifyContent="flex-start"
              >
                {data.nrocotizacion || "-"}
              </Text>
            </View>
            <View style={{ flexDirection: "row", alignItems: "space-between" }}>
              <Text fontSize="10px" padding="0px 3px" textAlign="start" >FECHA          </Text>
              <Text fontSize="10px" padding="0px 3px" textAlign="start" justifyContent="space-between">
                {dayjs().format("DD/MM/YYYY")}
              </Text>
            </View>

          </View>
        </View>
        <View justifyContent="center">
          <Text
            // alignItems="flex-center"
            fontSize="16px"
            bold
          >
            {isQuotation ? 'COTIZACIÓN' : 'PROFORMA'}
            {/* PROFORMA */}
          </Text>
        </View>

        <View
          border={{ top: true }}
          // style={{ marginTop: "5px" }}
          padding="3px 0px 0px 0px"
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                NIT:{" "}
              </Text>

            </Text>
          </View>
          <View width="65%">


            <Text padding="2px 3px">{data.company?.nit || "-"}</Text>

          </View>
        </View>
        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                CLIENTE:{" "}
              </Text>

            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">{data.company?.razonSocial || "-"}</Text>
          </View>
        </View>

        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                MERCADERIA:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.facturas}</Text> */}
            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">
              <Text padding="2px 3px">
                {data.descripciónDeLaMercancía || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.bultos}</Text> */}
            </Text>
          </View>
        </View>

        <View
        // style={{ marginTop: "5px" }}
        >

          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                VIA:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.facturas}</Text> */}
            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">
              <Text padding="2px 3px">
                {data.medioDeTransporte || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.bultos}</Text> */}
            </Text>
          </View>
        </View>
        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                FACTURA:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.senores}</Text> */}
            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">
              <Text padding="2px 3px">
                {data.nro_DeFactura || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.nit}</Text> */}
            </Text>
          </View>
        </View>
        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                PROVEEDOR:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.senores}</Text> */}
            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">
              <Text padding="2px 3px">
                {data.proveedor || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.nit}</Text> */}
            </Text>
          </View>
        </View>
        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                BULTOS:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.senores}</Text> */}
            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">
              <Text padding="2px 3px">
                {data.f3TotalNúmeroDeBultos || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.nit}</Text> */}
            </Text>
          </View>
        </View>
        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="35%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                PESO:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.senores}</Text> */}
            </Text>
          </View>
          <View width="65%">
            <Text padding="2px 3px">
              <Text padding="2px 3px">
                {data.f4TotalPesoBruto || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.nit}</Text> */}
            </Text>
          </View>

        </View>
        <View
        // style={{ marginTop: "5px" }}
        >
          <View width="15%" flexDirection="column">
            <Text padding="2px 3px">
              <Text padding="2px 3px" bold>
                CONTACTO:{" "}
              </Text>
              {/* <Text padding="2px 3px">{data.senores}</Text> */}
            </Text>
          </View>
          <View width="50%" borderContent >
            <Text padding="2px 3px">
              <Text padding="2px 3px" textAlign="center" justifyContent="center" alignItems="center">
                {data.contacto || "-"}
              </Text>
              {/* <Text padding="2px 3px">{data.nit}</Text> */}
            </Text>
          </View>

        </View>


        <View
          flexDirection="column"
          padding="5px"
          // border={{ top: true, bottom: true }}
          style={{ marginTop: "5px" }}
        >
          <View width="65%" >
            <View border={{ left: true, bottom: true, top: true }} width="75%" justifyContent="center">
              <Text padding="3px 3px" bold textAlign="center" >
                CONCEPTOS Y VALORES
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true, top: true }} width="25%" justifyContent="center">
              <Text padding="3px 3px" textAlign="center">
                U$
              </Text>
            </View>
          </View>
          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="75%" justifyContent="flex-start">
              <Text padding="3px 3px" textAlign="start">
                F.O.B.
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="space-between">
              <Text padding="3px 0px 3px 5px" textAlign="start"> $ </Text>
              <Text padding="3px 5px 3px 0px" textAlign="end">{parseValue(data.f6TotalValorFob).toFixed(2)}</Text>
            </View>
          </View>
          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="75%" justifyContent="flex-start">
              <Text padding="3px 3px" textAlign="start">
                FLETE I - II
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="space-between">
              <Text padding="3px 0px 3px 5px" textAlign="start"> $ </Text>
              <Text padding="3px 5px 3px 0px" textAlign="end">{fleteVal.toFixed(2)}</Text>
            </View>
          </View>
          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="75%" justifyContent="flex-start">
              <Text padding="3px 3px" textAlign="start">
                SEGURO
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="space-between">
              <Text padding="3px 0px 3px 5px" textAlign="start"> $ </Text>
              <Text padding="3px 5px 3px 0px" textAlign="end">{seguroVal.toFixed(2)}</Text>
            </View>
          </View>
          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="75%" justifyContent="flex-start">
              <Text padding="3px 3px" textAlign="start">
                OTROS GASTOS
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="space-between">
              <Text padding="3px 0px 3px 5px" textAlign="start"> $ </Text>
              <Text padding="3px 5px 3px 0px" textAlign="end">{parseValue(data["f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos"]).toFixed(2)}</Text>
            </View>
          </View>
          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="75%" justifyContent="flex-start">
              <Text padding="3px 3px" textAlign="start">
                GASTOS PUERTO
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="space-between">
              <Text padding="3px 0px 3px 5px" textAlign="start"> $ </Text>
              <Text padding="3px 5px 3px 0px" textAlign="end">{parseValue(data.gastosPuerto).toFixed(2)}</Text>
            </View>
          </View>
          
          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="75%" justifyContent="flex-start">
              <Text padding="3px 3px" textAlign="start">
                CIF.FRONTERA USD
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="space-between">
              <Text padding="3px 0px 3px 5px" textAlign="start"> $ </Text>
              <Text padding="3px 5px 3px 0px" textAlign="end">{cifUsdVal.toFixed(2)}</Text>
            </View>
          </View>



          <View width="65%" >
            <View border={{ left: true, bottom: true }} width="50%" >
              <View justifyContent="center" style={{ flex: 1 }}>
                <Text padding="3px 3px" textAlign="center" bold> tc </Text>
              </View>

              <View style={{ flex: 1 }} justifyContent="center">
                <Text padding="3px 3px" textAlign="center" bold> {tc} </Text>
              </View>

            </View>
            <View border={{ left: true, bottom: true }} width="25%" justifyContent="flex-start">
              <Text padding="3px 3px" bold >
                CIF. Bs.
              </Text>
            </View>
            <View border={{ right: true, left: true, bottom: true }} width="25%" justifyContent="flex-end">
              <View style={{ flex: 1 }} justifyContent="flex-end">
                <Text padding="3px 5px" textAlign="end">{cifBsVal.toFixed(2)}</Text>
              </View>
            </View>
          </View>

        </View>

        <View
          flexDirection="row"
          // padding="5px"
          style={{ marginTop: "5px" }}
        >

          {/* ------------------------------------------------------------- */}
          {/*  ⭐ SERVICIOS ADUANEROS (65%)                                */}
          {/* ------------------------------------------------------------- */}
          <View
            flexDirection="column"
            padding="5px"
            style={{ flex: 3 }}
          >
            {/* TÍTULO */}
            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true, top: true, right: true }} width="100%" justifyContent="center">
                <Text padding="3px 3px" bold textAlign="center" >
                  SERVICIOS ADUANEROS
                </Text>
              </View>
            </View>

            {/* FILAS DINÁMICAS */}
            {calculatedServices.map((item, idx) => {
              return (
                <View width="100%" key={idx} style={{ flexDirection: "row" }}>
                  <View
                    border={{ left: true, bottom: true }}
                    width="70%" style={{ flex: 2.5 }}
                  >
                    <Text padding="3px 3px" textAlign="start">
                      {item.label}
                    </Text>
                  </View>

                  <View
                    border={{ right: true, left: true, bottom: true }}
                    width="30%"
                  >
                    <View justifyContent="flex-start" style={{ flex: 1 }}>
                      <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                    </View>

                    <View style={{ flex: 1 }} justifyContent="flex-end">
                      <Text padding="3px 3px" textAlign="end"> {item.value.toFixed(2)}</Text>
                    </View>

                  </View>
                </View>
              );
            })}

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="70%" justifyContent="center" >
                <Text padding="3px 3px" bold textAlign="center" >
                  TOTAL
                </Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="30%" justifyContent="flex-end" >
                <Text padding="3px 3px" textAlign="end" >
                  {totalServicios.toFixed(2)}
                </Text>
              </View>
            </View>
          </View>

          {/* ESPACIO ENTRE TABLAS */}
          <View flexDirection="column" padding="5px" style={{ width: "20%", flex: 0.5 }} />


          {/* ------------------------------------------------------------- */}
          {/*  ⭐ TRIBUTOS ADUANEROS (35%)                                */}
          {/* ------------------------------------------------------------- */}
          <View
            flexDirection="column"
            padding="5px"
            style={{ flex: 2 }}
          >

            {/* TÍTULO */}
            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true, top: true, right: true }} width="100%" justifyContent="center">
                <Text padding="3px 3px" bold textAlign="center">
                  TRIBUTOS ADUANEROS
                </Text>
              </View>

            </View>
            <View width="100%" style={{ flexDirection: "row" }}  >
              <View border={{ left: true, bottom: true }} width="60%" justifyContent="center" height="50px">
                <Text padding="10px 3px" bold textAlign="center">

                </Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%" justifyContent="center">
                <Text padding="3px 3px" bold textAlign="center">
                  Bs.
                </Text>
              </View>

            </View>

            {/* FILAS */}
            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="60%" justifyContent="center">
                <Text padding="3px 3px" textAlign="center">BASE IMP.</Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%">
                <View width="30%" justifyContent="flex-start">
                  <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                </View>
                <View width="70%" justifyContent="flex-end">
                  <Text padding="3px 5px" textAlign="end"> {baseImpVal.toFixed(2)}</Text>
                </View>
              </View>
            </View>

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="40%">
                <Text padding="3px 3px">GA</Text>
              </View>
              <View border={{ left: true, bottom: true }} width="20%">
                <Text padding="3px 3px" textAlign="center">{data.gaPorcentaje}%</Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%">
                <View width="30%" justifyContent="flex-start">
                  <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                </View>
                <View width="70%" justifyContent="flex-end">
                  <Text padding="3px 5px" textAlign="end"> {gaVal.toFixed(2)}</Text>
                </View>
              </View>
            </View>

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="40%">
                <Text padding="3px 3px">IVA</Text>
              </View>
              <View border={{ left: true, bottom: true }} width="20%">
                <Text padding="3px 3px" textAlign="center">{data.ivaPorcentaje}%</Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%">
                <View width="30%" justifyContent="flex-start">
                  <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                </View>
                <View width="70%" justifyContent="flex-end">
                  <Text padding="3px 5px" textAlign="end"> {ivaVal.toFixed(2)}</Text>
                </View>
              </View>
            </View>

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="40%">
                <Text padding="3px 3px">ICE</Text>
              </View>
              <View border={{ left: true, bottom: true }} width="20%">
                <Text padding="3px 3px" textAlign="center">{data.icePorcentaje}%</Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%">
                <View width="30%" justifyContent="flex-start">
                  <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                </View>
                <View width="70%" justifyContent="flex-end">
                  <Text padding="3px 5px" textAlign="end"> {iceVal.toFixed(2)}</Text>
                </View>
              </View>
            </View>

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="40%">
                <Text padding="3px 3px">IEHD</Text>
              </View>
              <View border={{ left: true, bottom: true }} width="20%">
                <Text padding="3px 3px" textAlign="center">{data.iehPorcentaje}%</Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%">
                <View width="30%" justifyContent="flex-start">
                  <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                </View>
                <View width="70%" justifyContent="flex-end">
                  <Text padding="3px 5px" textAlign="end"> {iehdVal.toFixed(2)}</Text>
                </View>
              </View>
            </View>

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="40%">
                <Text padding="3px 3px">Uso de Sistema</Text>
              </View>
              <View border={{ left: true, bottom: true }} width="20%">
                <Text padding="3px 3px" textAlign="center"></Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%">
                <View width="30%" justifyContent="flex-start">
                  <Text padding="3px 3px" textAlign="start"> Bs. </Text>
                </View>
                <View width="70%" justifyContent="flex-end">
                  <Text padding="3px 5px" textAlign="end"> {usoSistemaVal.toFixed(2)}</Text>
                </View>
              </View>
            </View>

            <View width="100%" style={{ flexDirection: "row" }}>
              <View border={{ left: true, bottom: true }} width="60%" justifyContent="center" >
                <Text padding="3px 3px" bold textAlign="center" >
                  TOTAL
                </Text>
              </View>
              <View border={{ left: true, bottom: true, right: true }} width="40%" justifyContent="flex-end" >
                <Text padding="3px 3px" textAlign="end" >
                  {totalTributos.toFixed(2)}
                </Text>
              </View>
            </View>
          </View>

        </View>

        <View width="100%" style={{ flexDirection: "row", paddingTop: "10px" }}>

          {/* Cta. Corriente */}
          <View width="20%">
            <Text padding="3px 3px" fontSize="10" >Cta. Corriente</Text>
          </View>

          {/* Banco */}
          <View width="15%">
            <Text padding="3px 3px" fontSize="10" bold>B. Unión No.</Text>
          </View>

          {/* Número de cuenta */}
          <View border={{ bottom: true }} width="25%">
            <Text padding="3px 3px" fontSize="10" bold>{accountNumber || "No. 10000033357076"}</Text>
          </View>

          <View width="20%" style={{ flexDirection: "row" }} border={{ left: true, bottom: true, top: true }}>
            <View justifyContent="flex-start" style={{ flex: 1.5 }}>
              <Text padding="3px 3px" fontSize="10" textAlign="start"> Gran Total</Text>
            </View>

            <View style={{ flex: 0.5 }} justifyContent="flex-end">
              <Text padding="3px 3px" fontSize="10" textAlign="end">Bs.</Text>
            </View>
          </View>

          {/* BS. */}
          <View border={{ left: true, bottom: true, top: true }} justifyContent="flex-start" style={{ flex: 1 }}>
            <Text padding="3px 3px" fontSize="10" textAlign="start"> Bs. </Text>
          </View>

          <View border={{ right: true, bottom: true, top: true }} style={{ flex: 1 }} justifyContent="flex-end">
            <Text padding="3px 3px" fontSize="10" textAlign="end">{granTotal.toFixed(2)}</Text>
          </View>

        </View>

        <View width="100%" style={{ flexDirection: "row", paddingTop: "10px" }}>
          <Text fontSize="10px" padding="3px 3px" color="red" bold>
            Obs: La presente proforma es REFERENCIAL y VARIABLE en función de los documentos, TC y facturas finales.
          </Text>
        </View>

        <View fixed style={{ position: "absolute", bottom: 10, left: 20, right: 20, flexDirection: "row" }}>

          {/* COLUMNA IZQUIERDA */}
          <View flexDirection="column" padding="5px" style={{ flex: 4 }}>

            {/* UBICACIÓN */}
            <View width="100%" style={{ flexDirection: "row" }}>
              <View width="15%" justifyContent="flex-start" >
                <Text padding="3px 3px" textAlign="center" > Ubicacion: </Text>
              </View>
              <View width="85%" justifyContent="flex-start">
                <Text padding="3px 3px" textAlign="center" > Av.20 de Octubre #1915, Edificio Malaga Piso 2 Of 11B. ACIABOL Agencia despachante </Text>
              </View>
            </View>
            <View width="100%" style={{ flexDirection: "row" }}>
              <View width="15%" justifyContent="flex-start" >
                <Text textAlign="center" > email: </Text>
              </View> <View width="85%" justifyContent="flex-start">
                <Text padding="3px 3px" textAlign="center" > gerencia.aciabol@gmail.com </Text>
              </View>
            </View>



          </View>

          {/* COLUMNA DERECHA (CELULAR) */}
          <View flexDirection="column" padding="5px" style={{ flex: 1 }}>
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: "30%" }}>
                <Text padding="3px 3px" textAlign="center">Cel</Text>
              </View>
              <View style={{ width: "70%" }}>
                <Text padding="3px 3px" textAlign="end">77713481</Text>
              </View>
            </View>
            <View style={{
              position: "absolute",
              top: "8%",
              left: "30%",
              width: "100px", // ajusta tamaño
              height: "100px",
              opacity: 0.5, // opacidad baja para que sea marca de agua
              transform: "translate(20%, -20%)", // centra la imagen
              zIndex: 0,
            }}>
              <Image src={
                // 'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763749558/TRAZO/LOGOS/Imagen1_dwsaix.png'
                user?.institutionParam?.find(d => d.code === 'logo')?.value ?? ""
              } style={{ height: "70px" }} />
            </View>
          </View>

        </View>


      </Page>

    </Document>
  );

  return (
    <div>
      {
        !isQuotation &&
        <div className="flex justify-end mb-2">
          {/* <Button className="py-2" onClick={handleOnClick}>
            Guardar proforma <i className="fas fa-cloud-upload-alt"></i>
          </Button> */}
        </div>
      }
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
    </div>
  );
};

export default RenderSettlement;

const TextParagraph = ({ text, padding = "5px 10px", color = '#1a1a1a' }) => {
  return <View>
    <Text padding={padding} fontSize='10px' color={color} textAlign='justify'>
      {text}
    </Text>
  </View>
}

const TextSubTitle = ({ text }) => {
  return <View padding="5px 10px 5px">
    <Text padding="0px" textAlign='center' bold fontSize='10px' style={{ marginBottom: '1px', borderBottom: '1px solid black', fontWeight: 'bold' }}>
      {text}
    </Text>
  </View>
}
